var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.764 512H65.17C36.672 512 21.423 477.5 40.422 455.625L130.29 352H94.293C68.67 352 54.796 322.75 71.044 303.5L166.037 192H121.29C99.917 192 88.293 169.5 101.917 154.75L236.781 8.25C246.78 -2.75 265.279 -2.75 275.278 8.25L410.267 154.75C423.766 169.5 412.267 192 390.893 192H346.147L441.014 303.5C457.263 322.75 443.389 352 417.766 352H381.769L471.637 455.625C490.51 477.375 475.387 512 446.764 512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeLarge);
export default __webpack_public_path__ + "static/media/tree-large.f09c1dd75bacb1a82bcb1bfc68b5bed5.svg";
export { ForwardRef as ReactComponent };